import { ColumnViewModel } from '../../shared/column-types';

export const numDiseasesAssociatedToGene_SUMMARY: ColumnViewModel = {
  columns: [
    'diseaseName',
    'geneSymbol',
    'geneDescription',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'geneDPI',
    'geneDSI',
    'genepLI',
    'geneEnsemblIDs',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numCTs',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'prevalence',
    'disease_inheritance',
  ],
  defaultVisible: [
    'diseaseName',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numCTs',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'geneDSI',
    'geneDPI',
    'genepLI',
  ],
};
